// extracted by mini-css-extract-plugin
export default {"card":"dCqQb","text":"cKg6u","image":"sSlsD","cardTop":"KN3zF","cardBottom":"CZZR0","inversed":"Jm_UY","title":"rcXVC","subtitle":"NM1OQ","period":"_eJhO","discount":"Vyfvi"};